import { Report } from '@/app/models/costTracking';
import { Reports } from '@/app/models/costTrackingTotal';
import { FinancialGroup } from '@/app/models/financalGroup';
import { useSearchCostTrackingQuery, useSearchTotalityQuery } from '@/app/services/costTrackingApi';
import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import NewEditRubric from './NewEditRubric';
import NewEditRubricHeader from './NewEditRubricHeader';
import RubricTable from './RubricTable';
import RubricTableHeader from './RubricTableHeader';

interface RubricProps {
  group: FinancialGroup | undefined;
}

function Rubric(props: RubricProps) {
  const { code } = useParams();
  const { t } = useTranslation(['costTracking', 'common']);

  const { group } = props;

  const [drawerEditHeader, setDrawerEditHeader] = useState(false);
  const [drawerEdit, setDrawerEdit] = useState(false);

  const { data: totality } = useSearchTotalityQuery(
    {
      project: code || '',
      rubric: group?.code as string,
    },
    {
      skip: !code || !group,
    },
  );

  const { data: costTracking } = useSearchCostTrackingQuery(
    {
      project: code || '',
      rubric: group?.code as string,
    },
    {
      skip: !code || !group,
    },
  );

  const [selectedHeaderItem, setSelectedHeaderItem] = useState<Reports[]>();
  const [selectedItem, setSelectedItem] = useState<Report[]>();

  return (
    <Box>
      <PageTitle title={t('common:general.information')} sx={{ mb: 0 }} />

      <RubricTableHeader
        setDrawerEdit={setDrawerEditHeader}
        setSelectedHeaderItem={setSelectedHeaderItem}
        data={totality}
      />
      <PageTitle title={t('monthly.information')} sx={{ mt: -1, mb: 0 }} />
      <RubricTable setDrawerEdit={setDrawerEdit} setSelectedItem={setSelectedItem} data={costTracking} />
      <LateralDrawer open={drawerEditHeader} setOpen={setDrawerEditHeader} position="right" size="bigger">
        <NewEditRubricHeader selectItem={selectedHeaderItem as Reports[]} setDrawerOpen={setDrawerEditHeader} />
      </LateralDrawer>
      <LateralDrawer open={drawerEdit} setOpen={setDrawerEdit} position="right" size="bigger">
        <NewEditRubric selectItem={selectedItem as Report[]} setDrawerOpen={setDrawerEdit} />
      </LateralDrawer>
    </Box>
  );
}

export default Rubric;
